import React, { forwardRef } from 'react';
export const Alert = (StyledAlert) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAlert ref={ref} role={props?.role || 'alert'} {...props}>
        {children}
      </StyledAlert>);
});
